export default __webpack_public_path__ + "static/media/architecture3Eng.c75b7261.jpg";